import { render, staticRenderFns } from "./PersonCheck.vue?vue&type=template&id=4de6102c&scoped=true"
import script from "./PersonCheck.vue?vue&type=script&lang=js"
export * from "./PersonCheck.vue?vue&type=script&lang=js"
import style0 from "./PersonCheck.vue?vue&type=style&index=0&id=4de6102c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de6102c",
  null
  
)

export default component.exports